// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum PrefabPanel {
  PowerWired = 1,
  FullyWired = 2,
  FlexWired = 3,
  None = 4,
}
